module.exports = __webpack_public_path__ + "img/p1.a0145d77.jpg";